
import { Button, Row, Spin, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  getFeedbackForm,
  updateFeedbackForm,
  addFeedbackForm,
  updateFeedbackFormBySurveyId,

} from '../../services/feedbackService';
import FeedbackDetails from './FeedbackDetails';
import FeedbackEdit from './FeedbackEdit';
import FeedbackAdd from './FeedbackAdd';
import { Link } from 'react-router-dom';
import { getFeedbackTemplate } from '../../services/feedbackTemplateService';
import TableWithSorter from '../Common/TableWithSorter';
import FeedbackFormSection from './FeedbackFormSection';

function FeedbackInfo(props) {
  const { unitOfferId, unitOfferStartDate } = props;
  const [feedbackForms, setFeedbackForms] = useState([]);
  const [trainerFeedbackForms, setTrainerFeedbackForms] = useState([]);
  const [feedbackTemplates, setFeedbackTemplates] = useState([]);
  const [isEditFormModalOpen, setIsEditFormModalOpen] = useState(false);
  const [isEditTrainerFormModalOpen, setIsEditTrainerFormModalOpen] = useState(
    false
  );
  const [isAddFormModalOpen, setIsAddFormModalOpen] = useState(false);
  const [isAddTrainerFormModalOpen, setIsAddTrainerFormModalOpen] = useState(
    false
  );
  const [status, setStatus] = useState({
    type: 'LOADING',
    message: 'Loading data..',
  });
  const [editStatus, setEditStatus] = useState({
    type: 'IDLE',
    message: 'Idle mode..',
  });

  const dateFormat = 'dddd, Do MMMM YYYY h:mm:ssA Z';

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    setStatus({ type: 'LOADING', message: 'Loading data..' });
    await getFeedbackForm(unitOfferId)
      .then((response) => {
        const feedbackResponses = response.data.feedbackForm.map((form) => {
          return {
            ...form,
            startDate: moment(form.startDate).utc().local().format(dateFormat),
            endDate: moment(form.endDate).utc().local().format(dateFormat),
          };
        });
        const trainerFeedbackResponses = response.data.trainerFeedbackForm.map(
          (form) => {
            return {
              ...form,
              startDate: moment(form.startDate)
                .utc()
                .local()
                .format(dateFormat),
              endDate: moment(form.endDate).utc().local().format(dateFormat),
            };
          }
        );
        setFeedbackForms(feedbackResponses);
        setTrainerFeedbackForms(trainerFeedbackResponses);

        setStatus({ type: 'SUCCESS', message: 'Successfully loaded.' });
      })
      .catch((err) => {
        console.log('Error api failed.', err.response);
        setStatus({
          type: 'ERROR',
          message: err?.response?.data?.message ?? 'Something went wrong!',
          status: err?.response?.status ?? 400,
        });
      });
    await getFeedbackTemplate()
      .then((response) => {
        setFeedbackTemplates(
          response?.data?.paginatedList.filter(
            (template) => !template.isArchived
          )
        );
      })
      .catch((err) => {
        console.log('Error api failed.', err.response);
        setStatus({
          type: 'ERROR',
          message: err?.response?.data?.message ?? 'Something went wrong!',
          status: err?.response?.status ?? 400,
        });
      });
  }

  function toggleFormEdit() {
    setIsEditFormModalOpen((prev) => !prev);
  }

  function toggleTrainerFormEdit() {
    setIsEditTrainerFormModalOpen((prev) => !prev);
  }

  function toggleFormAdd() {
    setIsAddFormModalOpen((prev) => !prev);
  }

  function toggleTrainerFormAdd() {
    setIsAddTrainerFormModalOpen((prev) => !prev);
  }

  async function onSubmitEdit(values, surveyId) {
    let payload = {
      ...values,
      startDate: values.startDate.utc().format(),
      endDate: values.endDate.utc().format(),
    };
    if (validateDate(payload.startDate, payload.endDate)) {
      setEditStatus({ type: 'LOADING', message: 'Loading data...' });
      await updateFeedbackFormBySurveyId(surveyId, payload)
        .then(() => {
          fetchData();
          setEditStatus({ type: 'SUCCESS', message: 'Succesfully updated!' });
        })
        .catch((err) => {
          console.log(err);
          setEditStatus({
            type: 'ERROR',
            message: 'Something went wrong, Contact Admin!',
          });
        });
    } else
      setEditStatus({
        type: 'ERROR',
        message: 'Start date cannot be after end date!',
      });
  }

  async function onSubmitAdd(values) {
    let payload = {
      ...values,
      startDate: values.startDate.utc().format(),
      endDate: values.endDate.utc().format(),
    };
    if (validateDate(payload.startDate, payload.endDate)) {
      setEditStatus({ type: 'LOADING', message: 'Loading data...' });
      await addFeedbackForm(unitOfferId, payload)
        .then(() => {
          fetchData();
          setEditStatus({ type: 'SUCCESS', message: 'Succesfully Added!' });
          setStatus({ type: 'SUCCESS', message: 'Successfully loaded.' });
        })
        .catch((err) => {
          console.log(err);
          setEditStatus({
            type: 'ERROR',
            message: 'Something went wrong, Contact Admin!',
          });
        });
    } else
      setEditStatus({
        type: 'ERROR',
        message: 'Start date cannot be after end date!',
      });
  }

  function validateDate(startDate, endDate) {
    return new Date(startDate).getTime() < new Date(endDate).getTime();
  }

  if (status.type === 'LOADING') return <Spin size="large" />;
  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'For trainer?',
      dataIndex: 'forTrainer',
      key: 'forTrainer',
      render: (value) => <span>{value ? 'true' : 'false'}</span>,
    },
    {
      title: 'Start date',
      dataIndex: 'startDate',
      key: 'startDate',
    },
    {
      title: 'End date',
      dataIndex: 'endDate',
      key: 'endDate',
    },
    {
      title: 'Number of questions',
      dataIndex: 'questions',
      key: 'questions',
      render: (value) => <span>{value?.length}</span>,
    },
    {
      title: 'View Answer',
      dataIndex: '_id',
      key: '_id',
      render: (value) => <Link to={`/answers/feedback/${value}`}>Answer</Link>,
    },
  ];


  return (
    <div>
      <FeedbackFormSection
        title="Student Feedback Form"
        toggleFormAdd={toggleFormAdd}
        isAddFormModalOpen={isAddFormModalOpen}
        unitOfferStartDate={unitOfferStartDate}
        dateFormat={dateFormat}
        forTrainer={false}
        feedbackTemplates={feedbackTemplates}
        onSubmitAdd={onSubmitAdd}
        editStatus={editStatus}
        isEditFormModalOpen={isEditFormModalOpen}
        onSubmitEdit={onSubmitEdit}
        toggleFormEdit={toggleFormEdit}
        feedbackForms={feedbackForms}
        columns={columns}
      />
      <FeedbackFormSection
        title="Trainer Feedback Form"
        isAddFormModalOpen={isAddTrainerFormModalOpen}
        toggleFormAdd={toggleTrainerFormAdd}
        unitOfferStartDate={unitOfferStartDate}
        dateFormat={dateFormat}
        feedbackTemplates={feedbackTemplates}
        onSubmitAdd={onSubmitAdd}
        editStatus={editStatus}
        isEditFormModalOpen={isEditTrainerFormModalOpen}
        toggleFormEdit={toggleTrainerFormEdit}
        onSubmitEdit={onSubmitEdit}
        feedbackForms={trainerFeedbackForms}
        columns={columns}
        forTrainer={true}
      />
    </div>
  );
}

export default FeedbackInfo;
